/**
 * Created by DejanK on 1/22/2017.
 */
import { get, isEqual, noop, debounce } from 'lodash'
import IconHotelLastYearDefault from 'root/assets/images/map/hotel-last-year-default.png'
import IconHotelLastYearSelected from 'root/assets/images/map/hotel-last-year-selected.png'
import IconHotelDefault from 'root/assets/images/map/hotel-default.png'
import IconHotelSelected from 'root/assets/images/map/hotel-selected.png'
import IconOffice from 'root/assets/images/map/office.png'

export default TravelDestinationManagerMapService

TravelDestinationManagerMapService.$inject = ['RbGoogle', 'rbDialog', 'TravelDestinationManagerService'];
function TravelDestinationManagerMapService(RbGoogle, rbDialog, TravelDestinationManagerService){
  const $service = this
  let gMaps,
    map,
    destinationMarker,
    suppliersWithMarkers,
    focusedMarker,
    distanceCircle;

  $service.createMap = createMap;
  $service.panMapTo= panMapTo;
  $service.updateDestination = updateDestination;
  $service.updateDistanceCircle = updateDistanceCircle;
  $service.updateSuppliersMarkers = updateSuppliersMarkers;
  $service.checkAndUpdateSuppliersIcons = debounce(checkAndUpdateSuppliersIcons, 50);
  $service.updateShownProfile = updateFocusedMarker;
  $service.getSupplierWithMarker = getSupplierWithMarker;
  $service.getMap = getMap;

  onInit();

  function onInit(){
    RbGoogle.getMap().then(googleMaps => { gMaps = googleMaps }).catch( noop )
  }

  function createMap($element, center){
    if(gMaps){
      map = newMap($element, center);
      destinationMarker = null;
      suppliersWithMarkers = null;
      focusedMarker = null;
      distanceCircle = null;
    }
  }


  function getSupplierWithMarker(supplierId){ return suppliersWithMarkers.find(s => s.id === supplierId) }

  function getMap(){ return map }

  function panMapTo(coordinates){ if(map) map.panTo(coordinates) }

  function updateDestination(newDestination){
    if(gMaps) {
      removeDestinationMarker()
      destinationMarker = newDestinationMarker(newDestination)
    }
  }

  function updateDistanceCircle(distance){
    if(gMaps && distance && map){
      distanceCircle = distanceCircle ? updateDistanceCircleRadius(distanceCircle, distance) : newDistanceCircle(map, distance)
      const circleBounds = distanceCircle.getBounds()
      map.fitBounds(circleBounds);
      map.panToBounds(circleBounds);
    }
  }

  function updateSuppliersMarkers(newSuppliers){
    const newSuppliersWithMarkers = createNewSuppliersWithMarkers(suppliersWithMarkers, newSuppliers);
    removeOldMarkersFromMap(suppliersWithMarkers);
    suppliersWithMarkers = newSuppliersWithMarkers;

    /**
     * creates new markers or recycles old ones
     * @param {Array<Object>} oldSuppliersWithMarkers The existing suppliers with markers to be reused or replaced
     * @param {Array<Object>} ns The new suppliers to create or update markers for
     * @returns {Array} A new array of suppliers with markers
     */
    function createNewSuppliersWithMarkers(oldSuppliersWithMarkers, ns){
      const nsWithMarkers = [];
      if(gMaps) {
        if(ns) ns.forEach(newSupplier => {
          const oldSupplierWithMarkerIndex = oldSuppliersWithMarkers && oldSuppliersWithMarkers.findIndex( s => s.id === newSupplier.id )
          if (!oldSupplierWithMarkerIndex || oldSupplierWithMarkerIndex === -1) {
            nsWithMarkers.push(createSupplierWithMarker(newSupplier));
          } else {
            const oldSupplierWithMarker = oldSuppliersWithMarkers.splice(oldSupplierWithMarkerIndex, 1)[0];
            nsWithMarkers.push(updateSupplierWithMarker(oldSupplierWithMarker, newSupplier));
          }
        });
      }
      return nsWithMarkers;
    }

    function removeOldMarkersFromMap(oldMarkers){
      if(oldMarkers) oldMarkers.forEach(oldSupplierWithMarker => oldSupplierWithMarker.marker.setMap(null))
    }
  }

  function checkAndUpdateSuppliersIcons(suppliers){
    checkAndUpdateLists(suppliers);
    checkAndUpdateIcons();

    function checkAndUpdateLists(s){
      if(s && suppliersWithMarkers && s.length !== suppliersWithMarkers.length){
        updateSuppliersMarkers(s);
      }
    }

    function checkAndUpdateIcons() {
      if(suppliersWithMarkers) suppliersWithMarkers.forEach(supplierWithMarker => {
        if (supplierWithMarker.previousBidState !== supplierWithMarker.data.bidState) {
          updateIcon(supplierWithMarker.marker, supplierWithMarker.data);
          supplierWithMarker.previousBidState = supplierWithMarker.data.bidState;
        }
      })
    }
  }

  function getSupplierIcon(supplier) {
    let icon = ''

    if(supplier.bidState === 'NA') {
      icon = supplier.lastYear ? IconHotelLastYearDefault : IconHotelDefault;
    } else {
      icon = supplier.lastYear ? IconHotelLastYearSelected : IconHotelSelected
    }

    return icon;
  }

  function updateFocusedMarker(profileToShow){
    if(focusedMarker) removeFocus();
    if(profileToShow) setFocus(profileToShow);

    function removeFocus(){
      focusedMarker.marker.setIcon({
        url: focusedMarker.marker.getIcon().url,
        scaledSize: focusedMarker.saved.iconSize
      });
      focusedMarker.marker.setZIndex(focusedMarker.saved.zIndex);
      focusedMarker = null;
    }

    function setFocus(pts){
      const supplier = getSupplierWithMarker(pts);
      if(supplier) {
        const marker = supplier.marker,
          icon = marker.getIcon();
        focusedMarker = {
          marker: marker,
          saved: {
            iconSize: icon.scaledSize,
            zIndex: marker.getZIndex()
          }
        };

        marker.setIcon({
          url: icon.url,
          scaledSize: {width: 32, height: 34}
        });
        marker.setZIndex(6001);
      }
    }
  }


  function newMap($element, center){
    return new gMaps.Map($element[0], {
      center: center,
      zoom: 14,
      mapTypeId: 'roadmap',
      styles: [
        {
          featureType: 'poi.business',
          elementType: 'labels',
          stylers: [ { visibility: 'off' } ]
        }
      ]
    });
  }

  function newDestinationMarker(destination){
    return new gMaps.Marker({
      position: get(destination, 'location.coordinates'),
      map: map,
      icon: {
        url: IconOffice,
        scaledSize: {width: 30, height: 30}
      }
    })
  }

  function removeDestinationMarker(){
    if(destinationMarker) destinationMarker.setMap(null);
  }

  function newDistanceCircle(m, distance) {
    return new gMaps.Circle({
      center: m.getCenter(),
      radius: getMaxDistanceInMeters(distance),
      map: m,
      clickable: false,
      fillColor: '#00B8AB',
      fillOpacity: 0.1,
      strokeColor: '#ffffff',
      strokeOpacity: 0.9,
      strokeWeight: 1.5
    });
  }

  function updateDistanceCircleRadius(circle, distance){
    circle.setRadius(getMaxDistanceInMeters(distance));
    return circle;
  }

  function createSupplierWithMarker(supplier){
    const marker = new gMaps.Marker({
      position: supplier.location.coordinates,
      map: map,
      icon: {
        url : getSupplierIcon(supplier),
        scaledSize: {width: 24, height: 25}
      }
    });
    const markerWithData = {id: supplier.id, previousBidState: supplier.bidState, data: supplier, marker: marker};

    marker.addListener('click', function() {
      rbDialog.show('destinationManagerHotelProfile', { locals: {SupplierHotelId: supplier.id}} ).catch(noop)
    });

    marker.addListener('mouseover', function() {
      TravelDestinationManagerService.setFocusedSupplierId(supplier.id);
      TravelDestinationManagerService.scrollListTo(supplier.id);
    });

    marker.addListener('mouseout', function() {
      TravelDestinationManagerService.setFocusedSupplierId(null);
    });

    return markerWithData;
  }

  function updateSupplierWithMarker(supplierWithMarker, supplier){
    if(!isEqual(supplierWithMarker.data, supplier)){
      updateIcon(supplierWithMarker.marker, supplier);
      supplierWithMarker.data = supplier;
      supplierWithMarker.previousBidState = supplier.bidState;
    }
    return supplierWithMarker;
  }

  function updateIcon(supplierMarker, supplier){
    const currentIcon = supplierMarker.getIcon(),
      newIcon = getSupplierIcon(supplier);
    if(currentIcon.url !== newIcon){
      supplierMarker.setIcon({
        url : newIcon,
        scaledSize: currentIcon.scaledSize
      })
    }
  }

  function getMaxDistanceInMeters(distance){
    const distanceValue = distance.value;
    if(!distanceValue || distanceValue < 0) { return 0 }
    if(distanceValue > 50) { return 50*1609.344 }
    switch (distance.unit) {
      case 'KM':
        return distanceValue * 1000;
      case 'MI':
        return distanceValue * 1609.344;
      default :
        return 0;
    }
  }
}
